import type { ReactElement } from 'react';
import { toCurrency } from 'utils/numbers';

import UpcomingMenu from 'models/UpcomingMenu';
import type { MealSummary } from 'models/UpcomingMenu';

import ColoradoRDFLine from '../../Cart/shared/ColoradoRDFLine';

type Props = { item: UpcomingMenu; };

function SummarySection(label: string, value: number | string) {
  return (
    <div className="d-flex align-items-baseline justify-content-between">
      <div>{label}</div>
      <div className="c-order-details__hr" />
      <div>{value}</div>
    </div>
  );
}

function SummaryDetails({ item }: Props): ReactElement {
  const {
    price,
    shipping_surcharge: shippingSurcharge,
    shipping_fee: shippingFee,
    discount_amount: discountAmount,
    meals_summaries: mealsSummaries,
    sales_tax: salesTax,
    crd_fee: crdFee,
  } = item;
  const lgColumn = 'col-lg-6';

  return (
    <div className={`col-12 col-sm-5 ${lgColumn} c-order-details__summary`}>
      <span className="c-heading c-heading--brand-8">ORDER SUMMARY</span>

      <div className="u-text u-text--md">
        {mealsSummaries.map((summary: MealSummary, index) => {
          if (summary.count <= 0) return '';

          return (
            <div
              key={summary.name}
              className="d-flex align-items-baseline justify-content-between"
            >
              <div>
                {`${summary.count} ${summary.name}`}
              </div>
              <div className="c-order-details__hr" />
              <div>{toCurrency(summary.price)}</div>
            </div>
          );
        })}

        {SummarySection('Sales tax:', salesTax
          ? toCurrency(salesTax)
          : 'TBD')}

        {!!crdFee && ColoradoRDFLine(Number(crdFee))}

        {SummarySection('Shipping:', parseFloat(shippingFee) > 0
          ? toCurrency(shippingFee)
          : 'FREE')}

        {SummarySection('Extended Area Surcharge:', toCurrency(shippingSurcharge))}

        {!!Number(discountAmount) && SummarySection(
          'Discount:',
          toCurrency(-discountAmount),
        )}

        <div className="d-flex align-items-baseline justify-content-between">
          <div><strong>Total:</strong></div>
          <div className="c-order-details__hr" />
          <div><strong>{toCurrency(price)}</strong></div>
        </div>
      </div>
    </div>
  );
}

export default SummaryDetails;
